import { FC } from 'react';
import { Box, Chip, Typography, styled } from '@mui/material';

interface FilterChip {
	label: string;
	onDelete: () => void;
}

interface Props {
	filterName: string;
	chips: Array<FilterChip>;
}

export const SelectedFilter: FC<Props> = ({ filterName, chips }) => (
	<Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
		<Typography>{filterName}:</Typography>
		<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
			{chips.map(({ label, onDelete }) => (
				<ChipStyled key={label} label={label} onDelete={onDelete} />
			))}
		</Box>
	</Box>
);

const ChipStyled = styled(Chip)`
	background: #908ffa;
	padding: 0 8px 0 16px;
	height: 45px;
	border-radius: 22.5px;
	color: #fff;

	box-shadow: 4.65909px 4.65909px 18.63636px 0 #babecc, -7.45455px -7.45455px 9.31818px 0px #fff;

	.MuiChip-deleteIcon {
		color: #fff;
	}

	.MuiChip-deleteIcon:hover {
		color: rgba(255, 255, 255, 0.7);
	}
`;
